import { SelectOption } from '@/components/elements/select'

export const nutritionalValueMap: SelectOption[] = [
	{ label: '1 gramo', value: '1' },
	{ label: '2 gramos', value: '2' },
	{ label: '3 gramos', value: '3' },
	{ label: '4 gramos', value: '4' },
	{ label: '5 gramos', value: '5' },
	{ label: '6 gramos', value: '6' },
	{ label: '7 gramos', value: '7' },
	{ label: '8 gramos', value: '8' },
	{ label: '9 gramos', value: '9' },
	{ label: '10 gramos', value: '10' },
	{ label: '11 gramos', value: '11' },
	{ label: '12 gramos', value: '12' },
	{ label: '13 gramos', value: '13' },
	{ label: '14 gramos', value: '14' },
	{ label: '15 gramos', value: '15' },
	{ label: '16 gramos', value: '16' },
	{ label: '17 gramos', value: '17' },
	{ label: '18 gramos', value: '18' },
	{ label: '19 gramos', value: '19' },
	{ label: '20 gramos', value: '20' },
	{ label: '21 gramos', value: '21' },
	{ label: '22 gramos', value: '22' },
	{ label: '23 gramos', value: '23' },
	{ label: '24 gramos', value: '24' },
	{ label: '25 gramos', value: '25' },
	{ label: '26 gramos', value: '26' },
	{ label: '27 gramos', value: '27' },
	{ label: '28 gramos', value: '28' },
	{ label: '29 gramos', value: '29' },
	{ label: '30 gramos', value: '30' },
	{ label: '31 gramos', value: '31' },
	{ label: '32 gramos', value: '32' },
	{ label: '33 gramos', value: '33' },
	{ label: '34 gramos', value: '34' },
	{ label: '35 gramos', value: '35' },
	{ label: '36 gramos', value: '36' },
	{ label: '37 gramos', value: '37' },
	{ label: '38 gramos', value: '38' },
	{ label: '39 gramos', value: '39' },
	{ label: '40 gramos', value: '40' },
	{ label: '41 gramos', value: '41' },
	{ label: '42 gramos', value: '42' },
	{ label: '43 gramos', value: '43' },
	{ label: '44 gramos', value: '44' },
	{ label: '45 gramos', value: '45' },
	{ label: '46 gramos', value: '46' },
	{ label: '47 gramos', value: '47' },
	{ label: '48 gramos', value: '48' },
	{ label: '49 gramos', value: '49' },
	{ label: '50 gramos', value: '50' },
	{ label: '51 gramos', value: '51' },
	{ label: '52 gramos', value: '52' },
	{ label: '53 gramos', value: '53' },
	{ label: '54 gramos', value: '54' },
	{ label: '55 gramos', value: '55' },
	{ label: '56 gramos', value: '56' },
	{ label: '57 gramos', value: '57' },
	{ label: '58 gramos', value: '58' },
	{ label: '59 gramos', value: '59' },
	{ label: '60 gramos', value: '60' },
	{ label: '61 gramos', value: '61' },
	{ label: '62 gramos', value: '62' },
	{ label: '63 gramos', value: '63' },
	{ label: '64 gramos', value: '64' },
	{ label: '65 gramos', value: '65' },
	{ label: '66 gramos', value: '66' },
	{ label: '67 gramos', value: '67' },
	{ label: '68 gramos', value: '68' },
	{ label: '69 gramos', value: '69' },
	{ label: '70 gramos', value: '70' },
	{ label: '71 gramos', value: '71' },
	{ label: '72 gramos', value: '72' },
	{ label: '73 gramos', value: '73' },
	{ label: '74 gramos', value: '74' },
	{ label: '75 gramos', value: '75' },
	{ label: '76 gramos', value: '76' },
	{ label: '77 gramos', value: '77' },
	{ label: '78 gramos', value: '78' },
	{ label: '79 gramos', value: '79' },
	{ label: '80 gramos', value: '80' },
	{ label: '81 gramos', value: '81' },
	{ label: '82 gramos', value: '82' },
	{ label: '83 gramos', value: '83' },
	{ label: '84 gramos', value: '84' },
	{ label: '85 gramos', value: '85' },
	{ label: '86 gramos', value: '86' },
	{ label: '87 gramos', value: '87' },
	{ label: '88 gramos', value: '88' },
	{ label: '89 gramos', value: '89' },
	{ label: '90 gramos', value: '90' },
	{ label: '91 gramos', value: '91' },
	{ label: '92 gramos', value: '92' },
	{ label: '93 gramos', value: '93' },
	{ label: '94 gramos', value: '94' },
	{ label: '95 gramos', value: '95' },
	{ label: '96 gramos', value: '96' },
	{ label: '97 gramos', value: '97' },
	{ label: '98 gramos', value: '98' },
	{ label: '99 gramos', value: '99' },
	{ label: '100 gramos', value: '100' },
	{ label: '101 gramos', value: '101' },
	{ label: '102 gramos', value: '102' },
	{ label: '103 gramos', value: '103' },
	{ label: '104 gramos', value: '104' },
	{ label: '105 gramos', value: '105' },
	{ label: '106 gramos', value: '106' },
	{ label: '107 gramos', value: '107' },
	{ label: '108 gramos', value: '108' },
	{ label: '109 gramos', value: '109' },
	{ label: '110 gramos', value: '110' },
	{ label: '111 gramos', value: '111' },
	{ label: '112 gramos', value: '112' },
	{ label: '113 gramos', value: '113' },
	{ label: '114 gramos', value: '114' },
	{ label: '115 gramos', value: '115' },
	{ label: '116 gramos', value: '116' },
	{ label: '117 gramos', value: '117' },
	{ label: '118 gramos', value: '118' },
	{ label: '119 gramos', value: '119' },
	{ label: '120 gramos', value: '120' },
	{ label: '121 gramos', value: '121' },
	{ label: '122 gramos', value: '122' },
	{ label: '123 gramos', value: '123' },
	{ label: '124 gramos', value: '124' },
	{ label: '125 gramos', value: '125' },
	{ label: '126 gramos', value: '126' },
	{ label: '127 gramos', value: '127' },
	{ label: '128 gramos', value: '128' },
	{ label: '129 gramos', value: '129' },
	{ label: '130 gramos', value: '130' },
	{ label: '131 gramos', value: '131' },
	{ label: '132 gramos', value: '132' },
	{ label: '133 gramos', value: '133' },
	{ label: '134 gramos', value: '134' },
	{ label: '135 gramos', value: '135' },
	{ label: '136 gramos', value: '136' },
	{ label: '137 gramos', value: '137' },
	{ label: '138 gramos', value: '138' },
	{ label: '139 gramos', value: '139' },
	{ label: '140 gramos', value: '140' },
	{ label: '141 gramos', value: '141' },
	{ label: '142 gramos', value: '142' },
	{ label: '143 gramos', value: '143' },
	{ label: '144 gramos', value: '144' },
	{ label: '145 gramos', value: '145' },
	{ label: '146 gramos', value: '146' },
	{ label: '147 gramos', value: '147' },
	{ label: '148 gramos', value: '148' },
	{ label: '149 gramos', value: '149' },
	{ label: '150 gramos', value: '150' },
	{ label: '151 gramos', value: '151' },
	{ label: '152 gramos', value: '152' },
	{ label: '153 gramos', value: '153' },
	{ label: '154 gramos', value: '154' },
	{ label: '155 gramos', value: '155' },
	{ label: '156 gramos', value: '156' },
	{ label: '157 gramos', value: '157' },
	{ label: '158 gramos', value: '158' },
	{ label: '159 gramos', value: '159' },
	{ label: '160 gramos', value: '160' },
	{ label: '161 gramos', value: '161' },
	{ label: '162 gramos', value: '162' },
	{ label: '163 gramos', value: '163' },
	{ label: '164 gramos', value: '164' },
	{ label: '165 gramos', value: '165' },
	{ label: '166 gramos', value: '166' },
	{ label: '167 gramos', value: '167' },
	{ label: '168 gramos', value: '168' },
	{ label: '169 gramos', value: '169' },
	{ label: '170 gramos', value: '170' },
	{ label: '171 gramos', value: '171' },
	{ label: '172 gramos', value: '172' },
	{ label: '173 gramos', value: '173' },
	{ label: '174 gramos', value: '174' },
	{ label: '175 gramos', value: '175' },
	{ label: '176 gramos', value: '176' },
	{ label: '177 gramos', value: '177' },
	{ label: '178 gramos', value: '178' },
	{ label: '179 gramos', value: '179' },
	{ label: '180 gramos', value: '180' },
	{ label: '181 gramos', value: '181' },
	{ label: '182 gramos', value: '182' },
	{ label: '183 gramos', value: '183' },
	{ label: '184 gramos', value: '184' },
	{ label: '185 gramos', value: '185' },
	{ label: '186 gramos', value: '186' },
	{ label: '187 gramos', value: '187' },
	{ label: '188 gramos', value: '188' },
	{ label: '189 gramos', value: '189' },
	{ label: '190 gramos', value: '190' },
	{ label: '191 gramos', value: '191' },
	{ label: '192 gramos', value: '192' },
	{ label: '193 gramos', value: '193' },
	{ label: '194 gramos', value: '194' },
	{ label: '195 gramos', value: '195' },
	{ label: '196 gramos', value: '196' },
	{ label: '197 gramos', value: '197' },
	{ label: '198 gramos', value: '198' },
	{ label: '199 gramos', value: '199' },
	{ label: '200 gramos', value: '200' },
	{ label: '+200 gramos', value: '+200' },
]